import React, { useState } from 'react';

import Slider from "react-slick";
import Image from "react-bootstrap/Image";
import Accordion from 'react-bootstrap/Accordion';
import './OurTeam.css';

import img1 from './images/salini.jpeg';
import img2 from './images/priyanka.jpeg';
import img3 from './images/founder.jpeg';

const OurTeam=(props)=>{
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
  return (
<div id="OurTeam" class="container-fluid">
  <h1>Our Team</h1>
  <div class="container">
      <div class="row">
          <div class="col-lg-12">
            
            <Slider {...settings} className="slider-faculty">
     
      <div>
      <Image className="d-block  img-fluid mx-auto w-50" src={img1} alt="Third slide" roundedCircle thumbnail/><p>Mrs Mohini<br/>Managing Director </p>
      </div>
      <div>
      <Image className="d-block  img-fluid mx-auto w-50" src={img2} alt="Third slide" roundedCircle thumbnail/><p>Mrs. Priyanka Kumari<br/>Director  </p>
      </div>
      <div>
      <Image className="d-block  img-fluid mx-auto w-50" src={img3} alt="Third slide" roundedCircle thumbnail/><p>Mr. Devendra Prasad Yadav<br/>Chief Executive Officer</p>
      </div>
   
    </Slider>
           
          </div>
    
      </div>
  </div>
</div>
);
}

export default OurTeam;

